import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Container, Tab, Tabs } from "react-bootstrap";

export default function EditPlanPM() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleSubmitBranchStatus = (dataCallback) => {
    console.log(dataCallback);
    navigate("/PM_work/bind", { replace: true, state: "report" });
  };

  return (
    <>
      <Helmet>
        <title>ตรวจสอบสถานะสาขา</title>
        <meta name="description" content="Edit branch status" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs activeKey={state.name} justify className="mb-3">
          <Tab eventKey="details" title="รายละเอียดแผน PM"></Tab>
          <Tab eventKey="status" title="ตรวจสอบสถานะสาขา"></Tab>
          <Tab eventKey="report" title="รายงานแผน PM"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
